import {useCallback, useState} from "react";
import {useSnackbar} from "notistack";

const useDataModel = (apiHook) => {
    const [loading, setLoading] = useState(false)
    const [models, setModels] = useState([])
    const {enqueueSnackbar} = useSnackbar();

    const findModel = useCallback(
        id => models.find((m) => m?.id === id),
        [models]
    )

    const fetchModel = (id, callbackFn) => {
        setLoading(true)
        apiHook.getData(id).then(m => callbackFn(m)).finally(() => setLoading(false))
    }

    const postModel = (id, data, callbackFn) => {
        setLoading(true)
        apiHook.postData(id, data).then(m => callbackFn(m)).finally(() => setLoading(false))
    }

    const createModel = (data) => {
        setLoading(true)
        apiHook.createData(data).then(m => {
            setModels([...models, m])
            enqueueSnackbar('Hozzáadva!', {variant: 'success'})
        }).finally(() => setLoading(false))
    }

    const fetchModels = () => {
        setLoading(true)
        apiHook.getData().then(m => setModels(m)).finally(() => setLoading(false))
    }

    const updateModel = (id, data) => {
        setLoading(true)
        apiHook.updateData(id, data).then(m => {
            const editedModelList = models.map(model => {
                if (id === model.id) return {...model, ...m}
                return model;
            });
            setModels(editedModelList)
            enqueueSnackbar('Szerkesztve!', {variant: 'success'})
        }).finally(() => setLoading(false))
    }

    const deleteModel = id => {
        setLoading(true)
        apiHook.deleteData(id)
            .then(() => {
                setModels([...models.filter(m => m.id !== id)])
                enqueueSnackbar('Törölve!', {variant: 'success'})
            })
            .finally(() => setLoading(false))
    }


    return {
        loading,
        setLoading,
        models,
        setModels,
        findModel,
        fetchModel,
        fetchModels,
        createModel,
        updateModel,
        deleteModel,
        postModel,
    }
}

export default useDataModel